import { empty } from "uuidv4";

export default {
  default: "th",
  loginpage: {
    Mymeeting: 'การประชุมของฉัน',
    login: "เข้าสู่ระบบ",
    pleaslogin: "กรุณาเข้าสู่ระบบ",
    Successfully: "สำเร็จ",
    idpassincorrect: 'รหัสผู้ใช้ หรือ รหัสผ่าน ของคุณไม่ถูกต้อง',
    logout: "ออกจากระบบ",
    update: "อัปเดต",
    username: "ชื่อผู้ใช้งาน",
    usernameorpass: 'รหัสผู้ใช้งาน และ รหัสผ่าน',
    password: "รหัสผ่าน",
    Pleaseenter: 'กรุณากรอก',
    required: "จำเป็นต้องใส่",
    Pleasespecify: "กรุณาระบุ",
    Invitedby: "เชิญโดย",
    checkspace: "กรุณาตรวจสอบช่องว่าง",
    Invalidformat: "รูปแบบไม่ถูกต้อง",
    countTen: "ระบุตัวเลข 10 ตำแหน่ง",
    countSix: "อย่างน้อย 6 ตัวอักษร a-z, A-Z, 0-9",
    passdonot: "รหัสผ่านไม่ตรงกัน กรุณาพิมพ์ใหม่",
    nopass: "รหัสผ่านไม่ถูกต้อง",
    onlyeng: "เฉพาะตัวอักษรภาษาอังกฤษ",
    Letters: "ต้องมีตัวอักษรอย่างน้อย 8 ตัวอักษร และต้องมี a-z, A-Z, 0-9, ! @ # $ % ^ & * ( ) _ + | ~ -",
    duplicate: "ชื่อผู้ใช้ซ้ำกัน กรุณาลงทะเบียนใหม่",
    nameeng: "ชื่อ(ภาษาอังกฤษ)",
    name: "ชื่อ",
    email: "อีเมล",
    Tel: "เบอร์โทร",
    lastnameeng: "นามสกุล(ภาษาอังกฤษ)",
    company: "ชื่อบริษัท",
    confirmedPassword: "ยืนยันรหัสผ่าน",
    Register: "ลงทะเบียน",
    phone: "หมายเลขโทรศัพท์มือถือ",
    click: "คลิก",
    cancel: "ยกเลิก",
    joinin: "เข้าร่วมด้วยรหัส",
    qrcode: "แสดงQR CODE",
    user: "คุณมีบัญชี One Platform ใช่หรือไม่?",
    // oldversion: "กลับไปยังระบบ One Conference เวอร์ชั่นเก่า",
    notuser: "ยังไม่มีบัญชี One Platfrom",
    forgotpassword: "ลืมรหัสผ่าน",
    version: "เวอร์ชั่น",
    downloading: "กำลังดาวน์โหลด...",
    coppylink: "คัดลอก สำเร็จ",
    coppy: "คัดลอก",
    additional: "ข้อมูลเพิ่มเติม",
    Accept: "ยอมรับ",
    and: "และ",
    Privacy: "นโยบายความคุ้มครองข้อมูลส่วนบุคคล",
    oneid: "ข้อกำหนดการใช้บริการ",
    resendemail: "ส่ง E-mail อีกครั้ง",
    Instruction: "คู่มือการใช้งาน",
    Organizers: "คู่มือการใช้งานสำหรับผู้จัดการประชุม",
    participant: "คู่มือการใช้งานสำหรับผู้ร่วมประชุม",
    votesystem: "คู่มือการใช้งานโหวต",
    Pleasestandby: 'กรุณารอสักครู่',
    passcode: "กรุณาใส่ตัวเลขหรือตัวอักษรอังกฤษเท่านั้น",
    waiting: "กำลังขอเข้าร่วมประชุม .....",
    waitingHost: "กรุณารอโฮสต์อนุญาตให้เข้าร่วมประชุม คุณจึงจะเข้าร่วมประชุมได้",
  },
  roomsetting: {
    roomname: "ชื่อห้อง",
    linkmeeting: "ลิงก์เข้าประชุม",
    infomeeting: 'ข้อมูลการประชุม',
    copylink: "คัดลอกลิงก์",
    copyinfo: "คัดลอกข้อมูลห้องประชุม",
    setting: "ตั้งค่าเพิ่มเติม",
    detaimeeting: "คุณสามารถคัดลอกลิงก์นี้ส่งต่อเพื่อเชิญเข้าร่วมประชุม",
    passwordrooms: "รหัสเข้าห้องประชุม",
    alertpass: "ควรใช้รหัสความยาวอย่างน้อย 4 ตัวอักษร",
    secretmeeting: "การประชุมลับ",
    anonymous: "ผู้ใช้แบบไม่ยืนยันตัวตน",
    lock: "ล็อกห้องประชุม",
    invitemail: "เชิญอีเมล",
    subject: "เรื่อง",
    to: "ถึง",
    typeroom: "ประเภทการประชุม",
    normalmeeting: "การประชุมแบบปกติ",
    idrooms: "ไอดีห้อง",
    videoquality: "คุณภาพวิดีโอ",
    pass: "รหัสเข้าห้องประชุม",
    or: "หรือ",
    timeConflict: {
      title: "เวลาซ้ำกับการประชุมอื่น",
      message: "เวลาการประชุมที่คุณเลือกมีการซ้ำกับการประชุมอื่น กรุณาเลือกเวลาใหม่"
    }
  },
  managepage: {
    rooms: "เริ่มการประชุมทันที",
    roomsexpired: "บัญชีของคุณหมดอายุการใช้งาน",
    backrooms: "กลับเข้าร่วมการประชุม",
    schedule: "สร้างการประชุมไว้ใช้ภายหลัง",
  },
  shedulepage: {
    upcomingm: "การประชุมที่กำลังจะมาถึง",
    historym: "ประวัติการประชุม",
    share: "แชร์ลิงก์การประชุม",
    editroom: "แก้ไขการประชุม",
    delrroms: "ลบการประชุม",
    norecording: "ไม่มีวิดิโอบันทึกการประชุม",
  },
  upperpage: {
    vote: "ระบบโหวต",
    Storage: "พื้นที่เก็บ",
    setingprofile: "การตั้งค่าโปรไฟล์",
    csatButton: "แบบสำรวจความพึงพอใจ",
    csatTitle: "แบบสำรวจความพึงพอใจ",
    csatPrompt: "ต้องการทำแบบสำรวจความพึงพอใจตอนนี้หรือไม่?",
    csatYes: "ทำแบบสำรวจ",
    csatLater: "ไว้ภายหลัง",
    csatDoNotShow: "ไม่แสดงอีกใน 24 ชม."
  },
  joinpage: {
    attendmeet: "เข้าร่วมการประชุม",
    inputcode: "ป้อนไอดีห้องหรือลิงก์การประชุม",
    empty: "กรุณาใส่ลิงก์หรือรหัสการประชุมก่อนกดเข้าร่วมการประชุม",
  },
  Homepage: {
    cookie: "เราใช้คุกกี้เพื่อพัฒนาเว็บไซต์ของเราให้สะดวกต่อการใช้งานของคุณ การดำเนินการต่อบนเว็บไซต์นี้ถือว่าคุณยอมรับการใช้งานคุกกี้",
    company: "บริษัท อินเทอร์เน็ตประเทศไทย จำกัด (มหาชน)",
    address1: "1768 อาคารไทยซัมมิท ทาวเวอร์ ชั้น 10 - 12 และ IT",
    address2: "ถนนเพชรบุรีตัดใหม่ แขวงบางกะปิ เขตห้วยขวาง,",
    address3: "กรุงเทพมหานคร 10310",
    necessaryCookies: "คุกกี้พื้นฐานที่จำเป็น",
    performanceCookies: "คุกกี้ในส่วนวิเคราะห์",
    targetingCookies: "คุกกี้ในส่วนการตลาด",
    cookieSettings: "การตั้งค่าคุกกี้",
    cookieDescription: "จัดการการตั้งค่าคุกกี้",
    necessaryCookiesDescription: "คุกกี้พื้นฐานที่จำเป็น เพื่อช่วยให้การทำงานหลักของเว็บไซต์ใช้งานได้ รวมถึงการเข้าถึงพื้นที่ที่ปลอดภัยต่างๆ ของเว็บไซต์ หากไม่มีคุกกี้นี้เว็บไซต์จะไม่สามารถทำงานได้อย่างเหมาะสม และจะใช้งานได้โดยการตั้งค่าเริ่มต้น โดนไม่สามารถปิดการใช้งานได้",
    performanceDescription: "คุกกี้ในส่วนวิเคราะห์ จะช่วยให้เว็บไซต์เข้าใจรูปแบบการใช้งานของผู้เข้าชมและจะช่วยปรับปรุงประสบการณ์การใช้งาน โดยการเก็บรวบรวมข้อมูลและรายงานผลการใช้งานของผู้ใช้งาน",
    targetingDescription: "คุกกี้ในส่วนการตลาด ใช้เพื่อติดตามพฤติกรรมผู้เข้าชมเว็บไซต์เพื่อแสดงโฆษณาที่เหมาะสมสำหรับผู้ใช้งานแต่ละรายและเพื่อเพิ่มประสิทธิผลการโฆษณาสำหรับผู้เผยแพร่และผู้โฆษณาสำหรับบุคคลที่สาม",
    saveSettingsCooking: "บันทึกการตั้งค่า",
  },
  activatepage: {
    activate: "รหัสเปิดใช้งาน",
    nopermission: "บัญชีของคุณไม่ได้รับสิทธิ์ในการสร้างห้องประชุม",
    permission: "กรุณากรอกรหัสเพื่อเปิดสิทธิ์ในการสร้างห้องประชุม",
    nocode: "หากไม่มีรหัสกรุณาติดต่อผู้ดูแลระบบ",
    backtojoincode: "กลับไปหน้าเข้าร่วมด้วยรหัส"
  },
  button: {
    btnok: "ตกลง",
    btnnext: "ถัดไป",
    btnACCEPT: "ยอมรับ",
    btnSETTING: "การตั้งค่าคุกกี้",
    btneesend: "ส่งใหม่",
    btncancel: "ยกเลิก",
    btnback: "ย้อนกลับ",
    btncloserooms: "ปิดการประชุม",
    download: "ดาวน์โหลด",
    btnend: "สิ้นสุด",
    btnrecord: "บันทึก",
    btnreject: "ปฏิเสธ",
    btnstart: "เริ่มการประชุม",
    nottime: "ยังไม่ถึงเวลาประชุม",
    notstartyet: "ผู้จัดยังไม่เปิดห้องประชุม",
    attendmeeting: "เข้าร่วมประชุม",
    openroom: "เปิดการประชุมอื่นอยู่",
    didnmeeting: "ไม่เข้าร่วมการประชุม",
    restore: "คืนค่าเดิม"
  },
  message: {
    Sessiontimeout: "หมดเวลาการเข้าสู่ระบบ กรุณาเข้าสู่ระบบอีกครั้ง",
    Unabletologin: "ไม่สามารถเข้าสู่ระบบได้ข้อมูลไม่ถูกต้อง",
    entercode: "กรุณาใส่ CODE ให้ครบทุกช่อง",
    codealready: "CODE ถูกใช้งานไปแล้ว",
    administrator: "กรุณาติดต่อผู้ดูแล",
    incorrect: "ไม่ถูกต้อง",
    expired: "หมดอายุแล้ว",
    closemeeting: "กรุณาปิดห้องประชุม",
    newmeeting: "ไม่สามารถเปิดการประชุมใหม่ได้",
    delrooms: "คุณแน่ใจว่าต้องการลบห้องประชุมนี้",
    del: "ลบการประชุม",
    delroomsucces: "ลบการประชุมสำเร็จ",
    start: "เริ่ม",
    end: "สิ้นสุด",
    time: "เวลา",
    day: "วัน",
    Emailsent: "E-mailที่เคยส่งแล้ว สามารถส่งได้อีกครั้ง",
    Selectemail: "เลือก E-mail ที่ต้องการส่งอีกครั้ง",
    Addemail: "Add new Email to send",
    Addyouremail: "เพิ่ม E-mail ที่ต้องการ",
    closmeetingandopen: "กรุณา จบการประชุม ก่อนการ แก้ไขการประชุม",
    resources: "กำลังจัดเตรียมทรัพยากร กรุณารอสักครู่",
    readymeeting: "การประชุมพร้อมแล้ว",
    messageshare: "แชร์ลิงก์การประชุมนี้กับผู้ที่คุณต้องให้เข้าร่วมประชุม",
    canotclose: "มีผู้ร่วมประชุมอยู่ในห้องไม่สามารถปิดการประชุมได้",
    wrongcode: "ใส่รหัสหรือลิงก์ผิด",
    Entercodeorlink: "ป้อนไอดีห้องหรือลิงก์",
    tryagain: "กรุณาลองอีกครั้ง",
    nomeeting: "ไม่มีห้องประชุม",
    roomnotopened: "ห้องประชุมไม่ได้เปิด",
    pleasewait: "กรุณารอสักครู่",
    yousure: "คุณแน่ใจว่าต้องการ ลบวีดิโอบันทึกการประชุม",
    Noreport: "ไม่มีรายงานการประชุม",
    meetingclosed: "ห้องประชุมนี้ปิดให้บริการแล้ว",
    notstartedyet: "ห้องประชุมนี้ยังไม่ได้เริ่ม",
    cameraOff: "กล้องถูกปิดอยู่",
    loadingCamera: "กำลังเชื่อมต่อกล้อง...",
    cameraBlocked: "ระบบไม่ได้รับอนุญาตให้ใช้กล้อง กรุณาเปิดสิทธิ์การเข้าถึงในเบราว์เซอร์",
    micSelect: "ไมโครโฟน",
    camSelect: "กล้อง",
    checkMic: "ทดสอบไมโครโฟน",
    micCheckInProgress: "กรุณาพูดเพื่อทดสอบไมโครโฟน ระบบจะหยุดในไม่กี่วินาที",
    micCheckComplete: "ทดสอบไมโครโฟนเสร็จสิ้น",
    micCheckFailed: "ไม่สามารถเข้าถึงไมโครโฟนที่เลือกได้",
    micFallback: "ไมโครโฟน {index}",
    camFallback: "กล้อง {index}"
  },
  table: {
    datetime: "วันและเวลา",
    roomsname: "ห้องประชุม",
    statusrooms: "สถานะการประชุม",
    reportrooms: "รายงานการประชุม",
    settingmore: "จัดการเพิ่มเติม",
    videorecording: "วีดิโอบันทึกการประชุม",
    tablereport: "ตารางแสดงข้อมูลการเข้าประชุม",
    No: "ลำดับที่",
    Namemeet: "ชื่อผู้เข้าประชุม",
    timeinout: "เวลาที่เข้า - ออก",
    period: "ระยะเวลา",
    annotation: "หมายเหตุ",
    recording: "รายงานการบันทึกการประชุม",
    list: "รายการ",
    size: "ขนาดไฟล์",
    manage: "จัดการ",
    downloadrecord: "ดาวน์โหลดรายละเอียดการประชุม",
    Allmeeting: "รายงานประชุมทั้งหมด",
    Numberattendance: "จำนวนครั้งของการเข้าร่วมประชุม"
  },
  otp: {
    otpcodefrom: "กรุณากรอกรหัส OTP จาก SMS ก่อน",
    entering: "เข้าสู่การประชุม",
    Refcode: "รหัสอ้างอิง",
    otpincomplete: "ใส่รหัส OTP ไม่ครบ",
    otpcomplete: "การยืนยันตัวตนสำเร็จ",
    resendagain: "กรุณา Resend OTP อีกครั้ง",
    Invalidcode: "CODE ไม่ถูกต้อง"
  },
  settingprofile: {
    setting: "การตั้งค่า",
    profilesettings: "การตั้งค่าส่วนบุคคล",
    Meetingsettings: "การตั้งค่าการประชุม",
    btnprofilepick: "บันทึก (รูปโปรไฟล์)",
    btndelprofile: "ลบ (รูปโปรไฟล์)",
    editprofile: "แก้ไขโปรไฟล์",
    messageedit: "ต้องการเปลี่ยนรูป โปรไฟล์ ใช่ หรือ ไม่",
    messprofile: "กรุณาเลือกรูปโปรไฟล์"
  },
  settinglogo: {
    editlogo: "แก้ไข โลโก้",
    btnlogopick: "บันทึก (โลโก้)",
    namecompany: "ชื่อบริษัท",
    logoalready: "*ถ้า โลโก้ มีชื่อ บริษัท อยู่แล้วไม่จำเป็นต้องใส่",
    messelogo: "กรุณาเลือกรูป โลโก้",
    messageeditlogo: "ต้องการเปลี่ยนรูป โลโก้ ใช่ หรือ ไม่",
    Introduce: "ไม่แนะนำให้ใช้โลโก้สีขาว",
    pictruepng: "แนะนำให้ใช้รูปที่ไม่มีพื้นหลัง และ ขนาดภาพไม่เกิน 75 KB",
    restorelogo: "คืนค่า โลโก้",
    sizelogo: "ขนาดภาพที่แนะนำ 360 pixels * 360 pixels ขึ้นไป"
  }
}
